/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StationHealth } from '../../models/station-health';

export interface GetStationHealth$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getStationHealth(http: HttpClient, rootUrl: string, params: GetStationHealth$Params, context?: HttpContext): Observable<StrictHttpResponse<StationHealth>> {
  const rb = new RequestBuilder(rootUrl, getStationHealth.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StationHealth>;
    })
  );
}

getStationHealth.PATH = '/stations/{uid}/health';
